export default __webpack_public_path__ + "static/media/discounts-lunch-image.c3f7e7aa.svg";